<template>
	<div class="homework-textarea homework-int1" :class="count > 1 ? `text-indent-`+answerClassification.length : '' ">
		<template v-if="lineNumber>1">
			<template v-if="count > 1">
				<div v-if="answerClassification.length > 2" class="homework-item-txt">{{answerClassification}}:</div>
				<i v-else class="homework-icon" >{{answerClassification}}</i>
			</template>
			<template v-if="answerClassification.length > 2">
				<el-input type="textarea" :rows="lineNumber"  v-model="textValue" :placeholder ="`请输入${answerClassification}`"  :maxlength="restrict"  show-word-limit ></el-input>
			</template>
			<template v-else>
				<el-input type="textarea" :rows="lineNumber"  v-model="textValue" :placeholder="count > 1 ? `请输入内容` : answerClassification"  :maxlength="restrict"  show-word-limit ></el-input>
			</template>
		</template>

		<template v-else>
			<div v-if="answerClassification.length > 2" class="homework-item-txt homework-item-txt2 ">{{answerClassification}}:</div>
			<i v-else class="homework-icon homework-icon2" >{{answerClassification}}</i>
			<el-input type="text"  v-model="textValue" :maxlength="restrict"  show-word-limit></el-input>
		</template>
	</div>
</template>

<script>
export default {
	name: 'formItemText',
	props: {
		answerClassification:String,
		value: String,
		lineNumber: Number,
		restrict: String,
		count: Number,
	},
	watch: {
		textValue(val){
			this.$emit('input', val)
		}
	},
	data() {
		return {
			textValue: this.value
		}
	},
}
</script>

<style lang="scss" scoped>
.homework-item-txt{

		font-size: 16px;
		font-weight: bold;
		line-height: 20px;
		color: #666666;
		z-index: 99;
		margin-bottom: 10px;
	}
.homework-item-txt2{
	position: absolute;
	top: 9px;
}

.homework-textarea{
	position: relative;
	margin: 10px 20px 0;
}
.homework-icon{
		display: block;
		position: absolute;
		top: 4px;
		left: -14px;
		z-index: 99;

		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: #666;
	}
	.el-form-item{
		padding: 0 14px;
		margin-bottom: 16px;
	}
.homework-icon2{
		top: 7px;
}
.homework-int2,.homework-int3{
	.homework-item-txt{
		position: absolute;
		top: 15px;
		left: 0;
		font-size: 16px;
		font-weight: bold;
		line-height: 20px;
		color: #666666;
		z-index: 99;
	}

}
</style>
